<!--<div id="divForm">
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="example-form" autocomplete="off">
    <mat-form-field class="example-full-width">
      <mat-label>Username</mat-label>
      <input matInput type="text" name="" formControlName="username">
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <mat-label>Password</mat-label>
      <input matInput type="password" name="" formControlName="password">
    </mat-form-field>
  <button mat-raised-button color="primary">Enviar</button>
  </form>
</div>
-->
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<section class="page-wrapper">
  <header class="login-header">
    <img
      class="logo-img"
      src="assets/layout-img/logo-portada.png"
      alt="Panel de configuración de Ticketing"
      title="Panel de configuración de Ticketing"
    />
  </header>
  <div>
    Obteniendo información de usuario...
  </div>

  <footer class="login-footer">
    {{ this.Copyright }}
  </footer>
</section>
